const COUNTRY_PHONE_LENGTHS = {
  AU: 9,
  BD: 10,
  BR: 11,
  CA: 10,
  CN: 11,
  DE: 11,
  ES: 9,
  FR: 9,
  GB: 10,
  ID: 11,
  IN: 10,
  IT: 10,
  JP: 11,
  KR: 11,
  MX: 10,
  MY: 10,
  NZ: 9,
  PH: 10,
  PK: 10,
  QA: 8,
  SA: 9,
  SG: 8,
  TH: 9,
  TR: 10,
  US: 10,
  VN: 10,
  ZA: 9,
};

export const getCountryPhoneLength = (countryCode) => {
  if (!countryCode) {
    return 15;
  }

  return COUNTRY_PHONE_LENGTHS[countryCode] || 15;
};
